/* src/app/module/user-dashboard/period-selector/period-selector.component.scss */
.topbar {
  border-radius: 50px;
  padding: 4px 8px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.02);
}
.topbar ul {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  list-style-type: none;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
}
.topbar ul li {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 30px;
  transition: all 0.3s ease;
  color: #6b7280;
}
.topbar ul li:hover {
  font-weight: 600;
}
.topbar ul li.active {
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
  font-weight: 700;
  color: #000;
}
.topbar ul li:last-child {
  padding: 0;
  background: none;
}
:host ::ng-deep .p-inputtext {
  height: 36px !important;
  width: 240px !important;
  font-size: 14px;
}
.selectOptions {
  display: flex;
  flex-direction: column;
}
.selectOptions option {
  display: flex;
  flex-direction: column;
}
.dropdown {
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  padding: 12px;
  outline: none;
}
.dropdown:hover {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
label {
  margin-top: 10px;
}
.topbar-container {
  justify-content: space-between;
}
.topbar-container .heading h3 {
  font-size: 1.5rem;
  font-weight: bold;
}
.topbar-container .filter-dropdown {
  position: relative;
}
.topbar-container .filter-dropdown .date-filter {
  padding: 0.5rem 1rem;
  font-size: 1rem;
}
.topbar-container .filter-dropdown .calendar-wrapper {
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 0.5rem;
}
.text {
  font-size: 16px;
}
::ng-deep .p-calendar .p-datepicker {
  width: 400px;
  margin-top: 40px;
}
::ng-deep .p-datepicker-inline {
  display: inline-block;
  position: absolute !important;
  overflow-x: auto;
}
/*# sourceMappingURL=period-selector.component-HF4VSNBE.css.map */
